import { errorToast, successToast } from "./toast"

const forms = async () => {
    document.querySelectorAll("[data-members-form]").forEach(
        /** @param {HTMLFormElement} el */
        (el) => {
            const type = el.getAttribute("data-members-form") ?? 'signup'
            const mutationObserver = new MutationObserver((data) => {
                // const loading = el.classList.contains("loading")
                const success = el.classList.contains("success")
                const error = el.classList.contains("error")

                if (error) {
                    const errorMsg = el.querySelector("[data-members-error]").textContent
                    errorToast(errorMsg)
                } else if (success) {
                    if (type === "signin") {
                        successToast("Sent a login email to your email address")
                    } else if (type === "subscribe") {
                        successToast("Check your email for a link to confirm subscription")
                    } else if (type === "signup") {
                        successToast("Check your email for a link to confirm registration")
                    } else {
                        successToast("Sent a link to your email for confirmation")
                    }
                }
            })
            mutationObserver.observe(el, {attributes: true, attributeFilter: ["class"]})
        }
    )

    const forms = Array.from(document.querySelectorAll("[data-update-profile-form]"))


    try {
        if (forms.length === 0) return
        const memberRes = await fetch('/members/api/member/');
        const memberData = await memberRes.json();
        const contentKey = '96deda897602f5563d9486aef3'

        const newslettersRes = await fetch(`/ghost/api/content/newsletters?limit=100&key=${contentKey}`)
        const newslettersJson = await newslettersRes.json()

        forms.forEach((form) => {
            const nameInput = form.querySelector("[data-name-label]")
            const newsletterInputs = Array.from(form.querySelectorAll("[data-members-newsletter]"))
            form.addEventListener("submit", async (e) => {
                e.preventDefault()
                e.stopPropagation()
                form.classList.add("loading")
                const name = nameInput.value

                try {
                    const selectedNewsletters = newsletterInputs.flatMap((input) => {
                        if (!input.checked) return []
                        return [newslettersJson.newsletters.find((newsletter) => newsletter.name === input.value)]
                    })
                    const profileRes = await fetch("/members/api/member", {
                        method: "PUT",
                        headers: {"Content-Type": "application/json"},
                        body: JSON.stringify({name, newsletters: selectedNewsletters})
                    })
                    const profileJson = await profileRes.json()
                    if (!profileRes.ok) throw profileJson
                    document.querySelectorAll("[data-account-name-label]").forEach((label) => {
                        label.textContent = name
                    })
                    successToast("Successfully updated profile")
                } catch (err) {
                    console.error(err)
                    errorToast("Error updating profile")
                }
                form.classList.remove("loading")
            })
        })

        forms.forEach((form) => {
            const newsletterInputs = Array.from(form.querySelectorAll("[data-members-newsletter]"))
            newsletterInputs.forEach((input) => {
                const newsletterName = input.value
                input.checked = memberData.newsletters.find((newsletter) => newsletter.name === newsletterName) !== undefined
            })
        })
    } catch (_) {}
}

export default forms
